export const isBrowserTranscriptFallbackEnabled = (
  rawValue = process.env.REACT_APP_LIVE_INTERVIEW_BROWSER_TRANSCRIPT_FALLBACK
) => {
  if (rawValue == null) {
    // Default ON so live transcript remains visible even when server worker
    // is slow/unavailable in local environments.
    return true;
  }
  return ["1", "true", "yes", "on", "enabled"].includes(String(rawValue).trim().toLowerCase());
};
